<template>
  <input
    type="hidden"
    value="0"
  >
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'BazaarvoiceSettings',
    props: {
      bvUrl: { type: String, required: false, default: 'https://apps.bazaarvoice.com/deployments/cerave/main_site/staging/en_US/bv.js' }
    },
    mounted() {
      this.setBazaarVoiceUrl(this.bvUrl);
    },
    methods: {
      ...mapActions('bvStore', [
        'setBazaarVoiceUrl'
      ]),
    }
  };
</script>

<style>

</style>
